import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDStack, FDHeadlineText } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FoundationSummaries } from './TransitionsDashboardPageFoundationSummaries';
import TransitionsDashboardPageScheduledAchTransfersPicker from './TransitionsDashboardPageScheduledAchTransfersPicker/TransitionsDashboardPageScheduledAchTransfersPicker';
import TransitionsDashboardPageMeetingTranscripts from './TransitionsDashboardPageMeetingTranscriptsPicker/TransitionsDashboardPageMeetingTranscript/TransitionsDashboardPageMeetingTranscripts';
import TransitionsDashboardPageScheduledAchTransfers from './TransitionsDashboardPageScheduledAchTransfersPicker/TransitionsDashboardPageScheduledAchTransfers/TransitionsDashboardPageScheduledAchTransfers';
import TransitionsDashboardPageSections from './TransitionsDashboardPageSection/TransitionsDashboardPageSections';
import TransitionsDashboardPageMeetingTranscriptsPicker from './TransitionsDashboardPageMeetingTranscriptsPicker/TransitionsDashboardPageMeetingTranscriptsPicker';

export const TransitionsDashboardPageMetaOverride = buildFacetDesignOverride()
  .nameOverride('transitionsDashboardPageSections', {
    _component: () => TransitionsDashboardPageSections,
  }, overrideReadOnly)
  .nameOverride('transitionsDashboardPageMeetingTranscripts', {
    _component: () => TransitionsDashboardPageMeetingTranscripts,
  }, overrideReadOnly)
  .nameOverride('scheduledAchTransfers', {
    _component: () => TransitionsDashboardPageScheduledAchTransfers,
  }, overrideReadOnly)
  .nameOverride('foundationSummaries', {
    _component: () => FoundationSummaries,
  }, overrideReadOnly);


const TransitionsDashboardPageLayout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack spacing={2} direction={'row'} wrap paddingX={2}>
      <FDHeadlineText value={'Alerts'} color={'textSecondary'} />
      <MetaControlField attr={'transitionsDashboardPageSections'} />
      <FDStack direction={'column'} spacing={2} width={'100%'}>
        <FDHeadlineText value={'Member Details'} color={'textSecondary'} />
        <TransitionsDashboardPageMeetingTranscriptsPicker resource={resource} />
        <TransitionsDashboardPageScheduledAchTransfersPicker resource={resource} />
        <MetaControlField attr={'foundationSummaries'} />
      </FDStack>
    </FDStack>
  );
};

TransitionsDashboardPageLayout.defaultProps = {};

TransitionsDashboardPageLayout.propTypes = {};

export default TransitionsDashboardPageLayout;
